import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock,ButtonGroup,
     InputGroupButton,InputGroupText,
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from 'moment';
import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/inventario';

import Select from 'react-select';

import {api} from '../../actions/_request';
import ModalTablas from '../../components/catalogos/modal_tablas';
import FileUploader from './fileuploader';
import { debounce } from 'lodash';

import Impuestos from "../impuestos/Modal";
import Marcas from "../marcas/Modal";
import Estilos from "../estilos/Modal";
import Medidas from "../medidas/Modal";
import Colores from "../coloressabores/Modal";
import Categorias from "../categorias/modal";
import Proveedor from "../proveedores/Modal";

const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);
const unidades = [
    {label: 'Pieza', value:1},
    {label: 'Docena', value:2},
    {label: 'Par', value:3},
    {label: 'Paquete', value:4},
    {label: 'Kilo', value:5},
    {label: 'Gramo', value:7},
    {label: 'Litro', value:8},
    {label: 'Caja', value:9},
    {label: 'Metro', value:10},
    {label: 'Pie', value:11},
    {label: 'Pulgada', value: 12},
    {label: 'Servicio', value: 13},
    {label: 'No Aplica', value: 14},
    {label: 'Galon', value: 15},
    
];
const tasa_coutas = [
    {label: 'Tasa', value:1},
    {label: 'Cuota', value:2},       
];

const monedas = [
    {label: 'Pesos', value:1},
    {label: 'Dolares', value:2},       
];
const tipo_promocion = [
    {label: 'Fecha', value:1},
    {label: 'Cantidad', value:2},   
    {label: 'Ambas', value:3},     
];

// function debounce(a,b,c){var d,e;return function(){function h(){d=null,c||(e=a.apply(f,g))}var f=this,g=arguments;return clearTimeout(d),d=setTimeout(h,b),c&&!d&&(e=a.apply(f,g)),e}}
class ProveedorModal extends React.Component
{

    constructor(props)
    {
        super(props)

        this.state = {
            producto: {
                id:0,
                codigo_interno:'',
                nombre:'',
                activo:true,
                control_existencias:false,
                descripcion_corta:'',
                nombre2:'',
                linea:'',
                ubicacion:'',
                codigo:'',
                proveedor_id:0,
                prod_serv_id:0,
                unidad_id:0,
                costo:0,
                factor_es:0,
                unidad_compra:1,
                unidad_venta:1,
                tasa_cuota:1,
                factor_tasacouta:0,
                tiempo_entrega:0,
                peso_pieza:0,
                maximo:0,
                reorden:0,
                minimo:0,
                descuento_cliente:false,
                moneda_compra:1,
                moneda_venta:2,
                categoria_id:1,
                descuento_suite:0,
                actualizar:false,
                impuesto_compra1:0,
                impuesto_compra2:0,
                impuesto_venta1:0,
                impuesto_venta2:0,
                ieps_venta:0,
                ieps_compra:0,
                contado:0,
                credito:0,
                p3:0,
                p4:0,
                p5:0,
                porcentaje1:0,
                porcentaje2:0,
                porcentaje3:0,
                porcentaje4:0,
                porcentaje5:0,
                nota:'',
                promocion:true,
                tipo_promocion:1,
                fecha_inicio:'',
                fecha_final:'',
                precio_promocion:0,
                cantidad_promocion:0,
                marca:'',
                estilo:'',
                medida:'',
                color:'',
                pv1:0,
                pv2:0,
                pv3:0,
                pv4:0,
                pv5:0,
                volumen1:0,
                volumen2:0,
                volumen3:0,
                volumen4:0,
                volumen5:0,               
            },
            action: 'save',
            activeTab: '1',
            foto:null,
            ctegorias:[],
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',


            /*modal para agrgar nuevos registros*/
            modal_registro:0,
            tittle_registro:'',

            proveedor_codigo:'',
            proveedor_descripcion:"",
            prodser_descripcion:'',
            prodser_codigo:'',
            unidad_descripcion:'',
            unidad_codigo:'',
            codigo_impuesto_compra1:'',
            codigo_impuesto_compra2:'',
            codigo_impuesto_venta1:'',
            codigo_impuesto_venta2:'',
            porcentaje_compra1:'',
            porcentaje_compra2:'',
            porcentaje_venta1:'',
            porcentaje_venta2:'',
            linea_codigo:'',
            linea_descripcion:"",
            marca_codigo:'',
            marca_descripcion:"",
            estilo_codigo:'',
            estilo_descripcion:"",
            color_codigo:'',
            color_descripcion:"",
            medida_codigo:'',
            medida_descripcion:"",
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
        this.toggle_modal_registro= this.toggle_modal_registro.bind(this);          
    }

    handleClose (event) {
        console.log('evento--->',event)
         
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
         switch (name) {
            case "codigo_impuesto_compra1":                 
                  campo = "impuesto_compra1";
                  tabla="/impuesto";
                  break;
            case "codigo_impuesto_compra2":                  
                  campo = "impuesto_compra2";
                  tabla="/impuesto";
                  break;
            case "codigo_impuesto_venta1":                  
                  campo= "impuesto_venta1";
                  tabla="/impuesto";
                  break;
            case "codigo_impuesto_venta2":                  
                  campo = "impuesto_venta2";
                  tabla="/impuesto";
                  break;
            case "proveedor_codigo":                                  
                  campo = "proveedor_id";
                  tabla="/proveedor";                   
                  break;
            case "linea_codigo":                                  
                  campo = "categoria_id";
                  tabla="/categorias";                   
                  break;
            case "marca_codigo":                                  
                  campo = "marca";
                  tabla="/marca";                   
                  break;
            case "estilo_codigo":                                  
                  campo = "estilo";
                  tabla="/estilo";                   
                  break;
            case "color_codigo":                                  
                  campo = "color";
                  tabla="/colores";                   
                  break;
            case "medida_codigo":                                  
                  campo = "medida";
                  tabla="/medida";                   
                  break;




            case "prodser_codigo":                 
                  campo = "prod_serv_id";
                  tabla="/sat/productos_servicios_codigo";
                  break;
            case "unidad_codigo":                                  
                  campo ="unidad_id";
                   tabla="/sat/unidades_codigo";
                  break;
                    
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                     }
                     self.retorno(response.data,campo,vaciar,value);        
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
            

   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    foto(e)
    {
         e.preventDefault();
          let {producto} = this.state;
       
        
            console.log('foto en modal-->',fileObject)

            var fileObject = this.refs.uploader.getFileObject();

            let data = new FormData();
           data.append('data', fileObject);


        api().post(`foto`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
           
       
        
       
    }
    
     
    retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let descripcion="";
        let campo_codigo="";
        let campo_descripcion="";
        console.log('renglon---->',objeto);
        let {producto} = this.state;
        let self =this;
        switch (campo) {
            case "impuesto_compra1":
                  codigo=objeto.value?objeto.value:objeto.id,
                  descripcion=objeto.porcentaje;
                  campo_codigo="codigo_impuesto_compra1";
                  campo_descripcion="porcentaje_compra1"; 
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "impuesto_compra2":
                  codigo=objeto.value?objeto.value:objeto.id,
                  descripcion=objeto.porcentaje;
                  campo_codigo="codigo_impuesto_compra2";
                  campo_descripcion="porcentaje_compra2"; 
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "impuesto_venta1":
                  codigo=objeto.value?objeto.value:objeto.id,
                  descripcion=objeto.porcentaje;
                  campo_codigo="codigo_impuesto_venta1";
                  campo_descripcion="porcentaje_venta1"; 
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "impuesto_venta2":
                  codigo=objeto.value?objeto.value:objeto.id,
                  descripcion=objeto.porcentaje;
                  campo_codigo="codigo_impuesto_venta2";
                  campo_descripcion="porcentaje_venta2"; 
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "prod_serv_id":
                  codigo=objeto.clave,
                  descripcion=objeto.descripcion;
                  campo_codigo="prodser_codigo";
                  campo_descripcion="prodser_descripcion"; 
                  producto[campo] = objeto.id;
                  break;
            case "unidad_id":
                  codigo=objeto.codigo;
                  descripcion=objeto.nombre;
                  campo_codigo="unidad_codigo";
                  campo_descripcion="unidad_descripcion"; 
                  producto[campo] = objeto.id;
                  break;
            case "proveedor_id":
                  codigo=objeto.value?objeto.value:objeto.id;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="proveedor_codigo";
                  campo_descripcion="proveedor_descripcion"; 
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "categoria_id":
                  codigo=objeto.value?objeto.value:objeto.id;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="linea_codigo";
                  campo_descripcion="linea_descripcion"; 
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "marca":
                  codigo=objeto.value?objeto.value:objeto.id;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="marca_codigo";
                  campo_descripcion="marca_descripcion"; 
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "estilo":
                  codigo=objeto.value?objeto.value:objeto.id;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="estilo_codigo";
                  campo_descripcion="estilo_descripcion"; 
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "color":
                  codigo=objeto.value?objeto.value:objeto.id;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="color_codigo";
                  campo_descripcion="color_descripcion"; 
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "medida":
                  codigo=objeto.value?objeto.value:objeto.id;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="medida_codigo";
                  campo_descripcion="medida_descripcion"; 
                  producto[campo] = objeto.value?objeto.value:objeto.id;
                  break;         
        }  
       if(vacio==1){
        console.log('vaciar')
        codigo=valor;
        descripcion="";
        producto[campo] =0;
       }
        self.setState({
            producto : producto,           
            [campo_codigo]:codigo,
            [campo_descripcion]:descripcion,
            modal:false,         
        })
    }
    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }   

    modal_open(){
       document.getElementById('body').className = "modal-open modal-open";
    }
    toggle_modal_registro(objeto,opcion=0,titulo=''){
      // console.log('opcion---->'+opcion);
      if(opcion==0||opcion=='[object Event]'){
        // console.log('se agrega un modal-open')
        setTimeout(this.modal_open, 1000);
         
         //if(this.state.tabla_modal==14)
        //  document.getElementById('body').className = "modal-open modal-open";

        this.setState({
            modal : false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }else{
console.log('nada')
        this.setState({
            modal : !this.state.modal,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }
    }

    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
       

        if(name=="categoria_id" && value!=8){
            this.setState({
            producto: {
                ...this.state.producto,
                descuento_suite: 0,
                [name]: value
            }
        });
        }else{
             this.setState({
            producto: {
                ...this.state.producto,
                [name]: value
            }
        });
        }
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

    componentDidMount()
    {         
        let prospectoid = this.props.prospectoid;
        let self = this;  
         api().get('/categorias')
        .then(function(response)
        {
            self.setState({
                categorias : response.data
            });
           
        });            
        if(prospectoid > 0 && prospectoid != self.state.producto.id)
        {
            api().get(`inventario/${prospectoid}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                {           
                    console.log('activo-->',response.data.producto.activo);  
                    console.log('control_existencias-->',response.data.producto.control_existencias);    
                    console.log('actualizar-->',response.data.producto.actualizar); 
                    console.log('descuento_cliente-->',response.data.producto.descuento_cliente);
                    self.setState({
                        producto: response.data.producto,
                        proveedor_codigo:response.data.proveedor.codigo,
                        proveedor_descripcion:response.data.proveedor.nombre,
                        prodser_descripcion:response.data.prod_ser.nombre,
                        prodser_codigo:response.data.prod_ser.codigo,
                        unidad_descripcion:response.data.unidad.nombre,
                        unidad_codigo:response.data.unidad.codigo,
                        codigo_impuesto_compra1:response.data.imp_compra1.codigo,
                        codigo_impuesto_compra2:response.data.imp_compra2.codigo,
                        codigo_impuesto_venta1:response.data.imp_venta1.codigo,
                        codigo_impuesto_venta2:response.data.imp_venta2.codigo,
                        porcentaje_compra1:response.data.imp_compra1.nombre,
                        porcentaje_compra2:response.data.imp_compra2.nombre,
                        porcentaje_venta1:response.data.imp_venta1.nombre,
                        porcentaje_venta2:response.data.imp_venta2.nombre,
                        linea_codigo:response.data.categoria.codigo,
                        linea_descripcion:response.data.categoria.nombre,
                        marca_codigo:response.data.marca.codigo,
                        marca_descripcion:response.data.marca.nombre,
                        estilo_codigo:response.data.estilo.codigo,
                        estilo_descripcion:response.data.estilo.nombre,
                        color_codigo:response.data.color.codigo,
                        color_descripcion:response.data.color.nombre,
                        medida_codigo:response.data.medida.codigo,
                        medida_descripcion:response.data.medida.nombre,
                        foto:response.data.url,
                        action: 'update'
                    });
                }

            });
        }
        else if(prospectoid == null && self.state.producto.id)
        {            
            self.resetModal();
        }
    }

   

    resetModal(){
        this.setState({
          producto: {
                id:0,
                codigo_interno:'',
                nombre:'',
                activo:true,
                control_existencias:false,
                descripcion_corta:'',
                nombre2:'',
                linea:'',
                ubicacion:'',
                codigo:'',
                proveedor_id:0,
                prod_serv_id:0,
                unidad_id:0,
                costo:0,
                factor_es:0,
                unidad_compra:1,
                unidad_venta:1,
                tasa_cuota:1,
                factor_tasacouta:0,
                tiempo_entrega:0,
                peso_pieza:0,
                maximo:0,
                reorden:0,
                minimo:0,
                descuento_cliente:false,
                moneda_compra:1,
                moneda_venta:2,
                categoria_id:1,
                descuento_suite:0,
                actualizar:false,
                impuesto_compra1:0,
                impuesto_compra2:0,
                impuesto_venta1:0,
                impuesto_venta2:0,
                ieps_venta:0,
                ieps_compra:0,
                contado:0,
                credito:0,
                p3:0,
                p4:0,
                p5:0,
                porcentaje1:0,
                porcentaje2:0,
                porcentaje3:0,
                porcentaje4:0,
                porcentaje5:0,
                nota:'',
                promocion:true,
                tipo_promocion:1,
                fecha_inicio:'',
                fecha_final:'',
                precio_promocion:0,
                cantidad_promocion:0,
                marca:'',
                estilo:'',
                medida:'',
                color:'',
                pv1:0,
                pv2:0,
                pv3:0,
                pv4:0,
                pv5:0,
                volumen1:0,
                volumen2:0,
                volumen3:0,
                volumen4:0,
                volumen5:0,               
            },
            action: 'save',
            activeTab: '5',
            foto:null,
        });        
    }
    handleInputChange(event) {
        let {producto} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value=0;
            if(target.checked)
                value=1;
        }
        console.log('checked-->',value);

        producto[name] = value;
     
        this.setState({
            producto : producto
        });
    }
   
   
objeto_mayusculas(objeto){
         // for (var key in objeto) {
         //        if (objeto.hasOwnProperty(key)) {
         //            // var valor=String(objeto[key]).toUpperCase();                 
         //            // console.log('valor---->',valor)
                     
         //                 objeto[key] = String(objeto[key]).toUpperCase() ;
         //                 if( String(objeto[key]).toUpperCase()==='NULL')
         //                    objeto[key] ='';
                     
         //            // console.log(key + " = " + objeto[key]);
         //        }
         //      }
              return objeto;
    }
    handleSubmit(evt)
    {
        evt.preventDefault();
        let {producto,foto} = this.state;
        producto=this.objeto_mayusculas(producto);
        let self = this;
        var imagen = this.refs.uploader.getFileObject();
        var cambio = this.refs.uploader.cambio();
      // console.log('producto---->',JSON.stringify(producto));
      // console.log('imagen---->',imagen);
      // console.log('cambio---->',cambio);
      let data = new FormData();
           data.append('foto', imagen);
           data.append('item', JSON.stringify(producto));
           data.append('cambio', cambio);


           api().post(`/inventario_validar`, producto)
            .then(function(response)
            {
                let validacion=response.data.validacion;
                let encontrado=response.data.encontrado[0];

                if(validacion||(parseInt(encontrado.id)===parseInt(producto.id) )){

                  self.props[self.state.action](data,producto.id, () => {

                     self.props.alerta({
                      mensaje:"Producto Guardado correctamente!",
                      tipo:"success",
                      creacion:moment().format('Y-MM-DD H:m:s'),
                      });
                      self.resetModal();
                      self.props.toggle();
                    });
                  

                }else{
                    swal("Oops..", "El codigo ya existe");
                }
            });


          
      

    }

    render()
    {

       let {producto,categorias}=this.state;
  
        
        return(


           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal-80 modal_cliente">
                <form  onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                     <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Datos
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => { this.toggle_tab('2'); }}
                        >
                         Nota
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '3' })}
                          onClick={() => { this.toggle_tab('3'); }}
                        >
                         Existencias
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '4' })}
                          onClick={() => { this.toggle_tab('4'); }}
                        >
                         Precios y Promos
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '5' })}
                          onClick={() => { this.toggle_tab('5'); }}
                        >
                         Foto
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                     
                       <TabPane tabId="1">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-2">
                                <div className="form-group">
                                    
                                    <Label>Codigo *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    maxLength={20}
                                    name="codigo_interno"
                                    value={producto.codigo_interno} 
                                    onChange={ this.handleInputChange} 
                                    required
                                    className={"form-control"} />                                    
                                </div>
                            </div>                             
                                <div className="col-md-6">
                                    <FormGroup>
                                        <Label>Nombre *</Label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="nombre"
                                            value={producto.nombre}
                                            onChange={ this.handleInputChange}
                                            required
                                            className="form-control texto_normal"
                                            />
                                    </FormGroup>
                                </div>  
                                <div className="col-md-2 pt-2">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="activo" 
                                        checked={producto.activo }
                                        onChange={this.handleInputChange} 
                                        />&nbsp;&nbsp; activo
                                    </label>
                                    </div>
                                </div> 
                                <div className="col-md-2 pt-2">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="control_existencias" 
                                        checked={producto.control_existencias }
                                        onChange={this.handleInputChange}
                                        />&nbsp;&nbsp;Control Existencias
                                    </label>
                                    </div>
                                </div> 
                                <div className="col-md-6">
                                    <FormGroup>
                                        <Label>Descripcion Corta</Label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="descripcion_corta"
                                            value={producto.descripcion_corta}
                                            onChange={ this.handleInputChange}
                                            className="form-control texto_normal"
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-6">
                                    <FormGroup>
                                        <Label>Nombre 2</Label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="nombre2"
                                            value={producto.nombre2}
                                            onChange={ this.handleInputChange}
                                            className="form-control texto_normal"
                                            />
                                    </FormGroup>
                                </div> 
                                <div className="col-md-5">
                                    <FormGroup>
                                        <Label>Ubicación</Label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="ubicacion"
                                            value={producto.ubicacion}
                                            onChange={ this.handleInputChange}
                                            className="form-control texto_normal"
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-2">
                                    <FormGroup>
                                        <Label>Cod. Proveedor</Label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="codigo"
                                            value={producto.codigo}
                                            onChange={ this.handleInputChange}
                                            className="form-control texto_normal"
                                            />
                                    </FormGroup>
                                </div>
                                
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Categoria *:</label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="linea_codigo"
                                                    value={this.state.linea_codigo}
                                                     onChange={ this.ChangeCode}
                                                     onBlur={this.handleClose}
                                                    className="input_button form-control"
                                                    required
                                                    
                                                   
                                                    />
                                                    <Button onClick={ (button) => { this.toggle_modal(33,"Categorias","categoria_id") } }>...</Button>
                                                </div>
                                            </div>
                                        
                                        <div className="col-md-7 pt-4">
                                            <label className="">{this.state.linea_descripcion}</label>
                                        </div>
                                        </div>

                                    </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Proveedor *:</label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="proveedor_codigo"
                                                    value={this.state.proveedor_codigo}
                                                     onChange={ this.ChangeCode}
                                                     onBlur={this.handleClose}
                                                    className="input_button form-control"
                                                    
                                                   
                                                    />
                                                    <Button onClick={ (button) => { this.toggle_modal(14,"Proveedores","proveedor_id") } }>...</Button>
                                                </div>
                                            </div>
                                        
                                        <div className="col-md-7 pt-4">
                                            <label className="">{this.state.proveedor_descripcion}</label>
                                        </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Prod.  y servicio *:</label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="prodser_codigo"
                                                    value={this.state.prodser_codigo}
                                                    onChange={ this.ChangeCode}
                                                     onBlur={this.handleClose}
                                                    className="input_button form-control"
                                                    required
                                                    
                                                    />
                                                    <Button onClick={ (button) => { this.toggle_modal(12,"Productos y Servicios","prod_serv_id") } }>...</Button>
                                                </div>
                                            </div>
                                        
                                        <div className="col-md-7 pt-4">
                                            <label className="">{this.state.prodser_descripcion}</label>
                                        </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Codigo Unidad *: </label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="unidad_codigo"
                                                    value={this.state.unidad_codigo}
                                                    onChange={ this.ChangeCode}
                                                     onBlur={this.handleClose}
                                                    className="input_button form-control"
                                                    required
                                                    />
                                                    <Button onClick={ (button) => { this.toggle_modal(10,"Unidades","unidad_id") } }>...</Button>
                                                </div>
                                            </div>
                                        
                                        <div className="col-md-7 pt-4">
                                            <label className="">{this.state.unidad_descripcion}</label>
                                        </div>
                                        </div>

                                    </div>
                                    <div className="col-md-3">
                                    <FormGroup>
                                        <Label>ultimo Costo *</Label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="costo"
                                            value={producto.costo}
                                            onChange={ this.handleInputChange}
                                            className="form-control"
                                                    required
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                        <Label>Factor E/S *</Label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="factor_es"
                                            value={producto.factor_es}
                                            onChange={ this.handleInputChange}
                                            className="form-control"
                                                    required
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3"> 
                                <div className="form-group">
                                    <label className>Unidad Compra *:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="unidad_compra"
                                        options={unidades}
                                        value={parseInt(producto.unidad_compra) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'unidad_compra') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-md-3"> 
                                <div className="form-group">
                                    <label className>Unidad Venta *:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="unidad_venta"
                                        options={unidades}
                                        value={parseInt(producto.unidad_venta) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'unidad_venta') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-md-3"> 
                                <div className="form-group">
                                    <label className>Tasa o Couta:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="tasa_cuota"
                                        options={tasa_coutas}
                                        value={parseInt(producto.tasa_cuota ) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'tasa_cuota') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                    <FormGroup>
                                        <Label>Factor</Label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="factor_tasacuota"
                                            value={producto.factor_tasacuota}
                                            onChange={ this.handleInputChange}
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                        <Label>Tiempo Ent.</Label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="tiempo_entrega"
                                            value={producto.tiempo_entrega}
                                            onChange={ this.handleInputChange}
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                        <Label>Peso/Pieza</Label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="peso_pieza"
                                            value={producto.peso_pieza}
                                            onChange={ this.handleInputChange}
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                        <Label>Maximo</Label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="maximo"
                                            value={producto.maximo}
                                            onChange={ this.handleInputChange}
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                        <Label>Reorden</Label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="reorden"
                                            value={producto.reorden}
                                            onChange={ this.handleInputChange}
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                        <Label>Minimo</Label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="minimo"
                                            value={producto.minimo}
                                            onChange={ this.handleInputChange}
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3 pt-2">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="descuento_cliente" 
                                        checked={producto.descuento_cliente }
                                        onChange={this.handleInputChange}
                                        />&nbsp;&nbsp;Descuento Clientes
                                    </label>
                                    </div>
                                </div>
                                <div className="col-md-2"> 
                                <div className="form-group">
                                    <label className>Moneda Compra</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="moneda_compra"
                                        options={monedas}
                                        value={parseInt(producto.moneda_compra) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'moneda_compra') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-md-2"> 
                                <div className="form-group">
                                    <label className>Moneda Venta</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="moneda_venta"
                                        options={monedas}
                                        value={parseInt(producto.moneda_venta) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'moneda_venta') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                         
                            <div className="col-md-2">
                            <FormGroup>
                                <Label>Desc. Suite</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="descuento_suite"
                                    value={producto.descuento_suite}
                                    onChange={ this.handleInputChange}
                                    readOnly={parseInt(producto.categoria_id)===8?false:true}
                                    />
                            </FormGroup>
                        </div>    
                            <div className="col-md-3 pt-2">
                                    <div className="form-group mt-4">
                                    <label >
                                        <input type="checkbox"
                                        name="actualizar" 
                                        checked={producto.actualizar }
                                        onChange={this.handleInputChange}
                                        />&nbsp;&nbsp;Actualizar al Comprar
                                    </label>
                                    </div>
                                </div>
                                 <div className="col-md-6">
                                <div className="row mt-3 "> 
                                    <div className="col-md-12 div_titulo mr-2">
                                    <h1><span>Impuestos Compra</span></h1>
                                    <div className="row">                                    
                                     <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Impuesto 1 </label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="codigo_impuesto_compra1"
                                                    value={this.state.codigo_impuesto_compra1}
                                                    onChange={ this.ChangeCode}
                                                    onBlur={this.handleClose}
                                                    className="input_button_sm"
                                                   
                                                    />
                                                    <Button onClick={ (button) => { this.toggle_modal(15,"Impuestos","impuesto_compra1") } }>...</Button>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                            <b><label className="d-block">Porcentaje</label></b>
                                            <b><label className="mt-2">{this.state.porcentaje_compra1}</label></b>
                                        </div>
                                             <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Impuesto 2 </label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="codigo_impuesto_compra2"
                                                    value={this.state.codigo_impuesto_compra2}
                                                     onChange={ this.ChangeCode}
                                                     onBlur={this.handleClose}
                                                    className="input_button_sm"
                                                  
                                                    />
                                                    <Button onClick={ (button) => { this.toggle_modal(15,"Impuestos","impuesto_compra2") } }>...</Button>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                            <b><label className="d-block">Porcentaje</label></b>
                                            <b><label className="mt-2">{this.state.porcentaje_compra2}</label></b>
                                        </div>
                                    </div>
                                     </div>
                                    </div>
                                  <div className="row mt-3 "> 
                                    <div className="col-md-12 div_titulo mr-2">
                                    <h1><span>Impuestos Venta</span></h1>
                                    <div className="row">                                    
                                     <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Impuesto 1 </label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="codigo_impuesto_venta1"
                                                    value={this.state.codigo_impuesto_venta1}
                                                    onChange={ this.ChangeCode}
                                                    onBlur={this.handleClose}
                                                    className="input_button_sm"
                                                    
                                                    />
                                                     <Button onClick={ (button) => { this.toggle_modal(15,"Impuestos","impuesto_venta1") } }>...</Button>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                            <b><label className="d-block">Porcentaje</label></b>
                                            <b><label className="mt-2">{this.state.porcentaje_venta1}</label></b>
                                        </div>
                                             <div className="col-md-4"> 
                                                <div className="form-group">
                                                    <label className="d-block">Impuesto 2 </label>
                                                    <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="codigo_impuesto_venta2"
                                                    value={this.state.codigo_impuesto_venta2}
                                                    onChange={ this.ChangeCode}
                                                    onBlur={this.handleClose}
                                                    className="input_button_sm"
                                                    
                                                    />
                                                   <Button onClick={ (button) => { this.toggle_modal(15,"Impuestos","impuesto_venta2") } }>...</Button>
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                            <b><label className="d-block">Porcentaje</label></b>
                                            <b><label className="mt-2">{this.state.porcentaje_venta2}</label></b>
                                        </div>
                                    </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3 "> 
                                      <div className="col-md-12 div_titulo mr-2">
                                        <h1><span>I.E.P.S</span></h1>
                                        <div className="row ">
                                          <div className="col-md-4">
                                            <FormGroup>
                                              <Label>Venta</Label>
                                              <InputGroup>                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="ieps_venta"
                                                        value={(producto.ieps_venta)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    <InputGroupAddon>%</InputGroupAddon>                                                    
                                                </InputGroup>
                                            </FormGroup>
                                          </div>
                                          <div className="col-md-4">
                                            <FormGroup>
                                              <Label>Compra</Label>
                                              <InputGroup>                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="ieps_compra"
                                                        value={(producto.ieps_compra)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    <InputGroupAddon>%</InputGroupAddon>                                                    
                                                </InputGroup>
                                          </FormGroup>
                                          </div> 
                                        </div>
                                      </div> 
                                    </div>                               


                                </div>


                                 <div className="col-md-6">
                                    <div className="row mt-3">
                                    <div className="col-2"/>
                                        <div className="col-4">
                                            <div className="form-group">
                                                <label className>Precios</label>
                                                <InputGroup>
                                                <InputGroupAddon>1-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="credito"
                                                        value={(producto.credito)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">
                                                <label className>% Utilidad</label>
                                                <InputGroup>
                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="porcentaje1"
                                                        value={(producto.porcentaje1)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-2"/>
                                        <div className="col-2"/>
                                        <div className="col-4">
                                            <div className="form-group">                                                
                                                <InputGroup>
                                                <InputGroupAddon>2-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="contado"
                                                        value={(producto.contado)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">                                                
                                                <InputGroup>
                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="porcentaje2"
                                                        value={(producto.porcentaje2)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-2"/>
                                        <div className="col-2"/>
                                        <div className="col-4">
                                            <div className="form-group">                                               
                                                <InputGroup>
                                                <InputGroupAddon>3-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="p3"
                                                        value={(producto.p3)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">                                                
                                                <InputGroup>                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="porcentaje3"
                                                        value={(producto.porcentaje3)}
                                                        onChange={this.handleInputChange}
                                                    />                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-2"/>
                                        <div className="col-2"/>
                                        <div className="col-4">
                                            <div className="form-group">                                               
                                                <InputGroup>
                                                <InputGroupAddon>4-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="p4"
                                                        value={(producto.p4)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">                                                
                                                <InputGroup>                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="porcentaje4"
                                                        value={(producto.porcentaje4)}
                                                        onChange={this.handleInputChange}
                                                    />                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-2"/>
                                        <div className="col-2"/>
                                        <div className="col-4">
                                            <div className="form-group">                                               
                                                <InputGroup>
                                                <InputGroupAddon>5-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="p5"
                                                        value={(producto.p5)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">                                                
                                                <InputGroup>                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="porcentaje5"
                                                        value={(producto.porcentaje5)}
                                                        onChange={this.handleInputChange}
                                                    />                                                    
                                                </InputGroup>
                                            </div>
                                        </div>

                                        
                                        
                                        </div>

                                    </div>







                                </div>                                 
                                                      
                                                 
                          </Col>
                        </Row>
                      </TabPane> 
                      <TabPane tabId="2">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Nota</label>
                                    <Input
                                      rows={10}                                                        
                                      type="textarea"
                                      name="nota"
                                      className="form-control texto_normal"
                                      value={producto.nota} 
                                      maxLength={450}
                                      onChange={ this.handleInputChange}
                                      />
                                    
                                </div>
                            </div>                                   
                                                      
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane> 
                      <TabPane tabId="3">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Existencias</label>
                                    <Input
                                      rows={10}                                                        
                                      type="textarea"
                                      name="nota"
                                      value={producto.nota} 
                                      maxLength={450}
                                      onChange={ this.handleInputChange}
                                      />
                                    
                                </div>
                            </div>                                   
                                                      
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane> 
                      <TabPane tabId="4">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 p-3 form_cliente">
                          <div className="col-md-4 mr-1">
                          <div className="row mt-3 "> 
                                    <div className="col-md-12 div_titulo mr-2">
                                    <h1><span>Promoción</span></h1>
                                    <div className="row">                                  
                                        <div className="col-md-6 pt-2">
                                            <div className="form-group mt-4">
                                                <label >
                                                    <input type="checkbox"
                                                    name="promocion" 
                                                    checked={producto.promocion }
                                                    onChange={this.handleInputChange}
                                                    />&nbsp;&nbsp;En Promocion
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-6"> 
                                <div className="form-group">
                                    <label className>Tipo Promoción</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="tipo_promocion"
                                        options={tipo_promocion}
                                        value={parseInt(producto.tipo_promocion) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'tipo_promocion') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                                 
                                    <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className>Fecha de Inicio:</label>
                                                        <input
                                                            type="date" 
                                                            className="form-control"
                                                            name="fecha_inicio"
                                                            value={producto.fecha_inicio || ''}
                                                            onChange={this.handleInputChange}
                                                            
                                                        />
                                                    </div>
                                                </div>
                                    <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className>Fecha de Final:</label>
                                                        <input
                                                            type="date" 
                                                            className="form-control"
                                                            name="fecha_final"
                                                            value={producto.fecha_final || ''}
                                                            onChange={this.handleInputChange}
                                                            
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                    <FormGroup>
                                        <Label>Precio</Label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="precio_promocion"
                                            value={producto.precio_promocion}
                                            onChange={ this.handleInputChange}
                                            />
                                    </FormGroup>
                                </div>
                                <div className="col-md-6">
                                    <FormGroup>
                                        <Label>Cantidad</Label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="cantidad_promocion"
                                            value={producto.cantidad_promocion}
                                            onChange={ this.handleInputChange}
                                            />
                                    </FormGroup>
                                </div>
                                </div>
                                </div>



                                        
                                                                                 
                                        </div>

                                    </div> 
                              <div className="col-md-3 mr-1">
                              <div className="row mt-3 "> 
                                    <div className="col-md-12 div_titulo mr-2">
                                    <h1><span>Precios Por Volumen</span></h1>
                                    <div className="row">
                                        <div className="col-8">
                                            <div className="form-group">
                                                <label className>Precios</label>
                                                <InputGroup>
                                                <InputGroupAddon>1-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="pv1"
                                                        value={(producto.pv1)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">
                                                <label className>Volumen</label>
                                                <InputGroup>
                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="volumen1"
                                                        value={(producto.volumen1)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-8">
                                            <div className="form-group">                                                
                                                <InputGroup>
                                                <InputGroupAddon>2-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="pv2"
                                                        value={(producto.pv2)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">                                                
                                                <InputGroup>
                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="volumen2"
                                                        value={(producto.volumen2)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-8">
                                            <div className="form-group">                                               
                                                <InputGroup>
                                                <InputGroupAddon>3-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="pv3"
                                                        value={(producto.pv3)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">                                                
                                                <InputGroup>                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="volumen3"
                                                        value={(producto.volumen3)}
                                                        onChange={this.handleInputChange}
                                                    />                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-8">
                                            <div className="form-group">                                               
                                                <InputGroup>
                                                <InputGroupAddon>4-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="pv4"
                                                        value={(producto.pv4)}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">                                                
                                                <InputGroup>                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="volumen4"
                                                        value={(producto.volumen4)}
                                                        onChange={this.handleInputChange}
                                                    />                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-8">
                                            <div className="form-group">                                               
                                                <InputGroup>
                                                <InputGroupAddon>5-</InputGroupAddon>
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="pv5"
                                                        value={(producto.pv5)}
                                                        onChange={this.handleInputChange}
                                                    />                                                    
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">                                                
                                                <InputGroup>                                                
                                                    <input
                                                        type="number" 
                                                        className="form-control"
                                                        name="volumen5"
                                                        value={(producto.volumen5)}
                                                        onChange={this.handleInputChange}
                                                    />                                                    
                                                </InputGroup>
                                            </div>
                                        </div>

                                        
                                        
                                        </div>
                                        </div>
                                        </div>




                                    </div>

                                    <div className="col-md-4">
                                     <div className="row mt-3 "> 
                                    <div className="col-md-12 div_titulo mr-2">
                                    <h1><span>Extra</span></h1>


                                    <div className="row">
                                    <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6"> 
                                                <div className="form-group">
                                                    <label className="d-block">Marca: </label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="marca_codigo"
                                                    value={this.state.marca_codigo}
                                                    onChange={ this.ChangeCode}
                                                    onBlur={this.handleClose}
                                                    className="input_button"
                                                    />
                                                     <Button onClick={ (button) => { this.toggle_modal(17,"Marcas","marca") } }>...</Button>
                                                </div>
                                            </div>
                                        
                                        <div className="col-md-6 pt-4">
                                            <label className="">{this.state.marca_descripcion}</label>
                                        </div>
                                        </div>

                                    </div>   
                                    <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6"> 
                                                <div className="form-group">
                                                    <label className="d-block">Estilo: </label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="estilo_codigo"
                                                    value={this.state.estilo_codigo}
                                                    onChange={ this.ChangeCode}
                                                    onBlur={this.handleClose}
                                                    className="input_button"
                                                    />
                                                     <Button onClick={ (button) => { this.toggle_modal(18,"Estilos","estilo") } }>...</Button>
                                                </div>
                                            </div>
                                        
                                        <div className="col-md-6 pt-4">
                                            <label className="">{this.state.estilo_descripcion}</label>
                                        </div>
                                        </div>

                                    </div>  
                                    <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6"> 
                                                <div className="form-group">
                                                    <label className="d-block">Medida: </label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="medida_codigo"
                                                    value={this.state.medida_codigo}
                                                    onChange={ this.ChangeCode}
                                                    onBlur={this.handleClose}
                                                    className="input_button"
                                                    />
                                                     <Button onClick={ (button) => { this.toggle_modal(20,"Medidas","medida") } }>...</Button>
                                                </div>
                                            </div>
                                        
                                        <div className="col-md-6 pt-4">
                                            <label className="">{this.state.medida_descripcion}</label>
                                        </div>
                                        </div>

                                    </div>  
                                    <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6"> 
                                                <div className="form-group">
                                                    <label className="d-block">Color: </label>
                                                    <Input
                                                    placeholder=""
                                                    type="text"
                                                    name="color_codigo"
                                                    value={this.state.color_codigo}
                                                    onChange={ this.ChangeCode}
                                                    onBlur={this.handleClose}
                                                    className="input_button"
                                                    />
                                                     <Button onClick={ (button) => { this.toggle_modal(19,"Colores / Sabores","color") } }>...</Button>
                                                </div>
                                            </div>
                                        
                                        <div className="col-md-6 pt-4">
                                            <label className="">{this.state.color_descripcion}</label>
                                        </div>
                                        </div>

                                    </div>                          
                               
                                
                                        
                                                                                 
                                        </div>
                                        </div>
                                        </div>

                                    </div> 
                                                                       
                                                      
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane> 
                      <TabPane tabId="5">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <FileUploader ref="uploader" url={this.state.foto}/>                                    
                                    
                                </div>
                            </div>                                   
                                                      
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane>                    
                    </TabContent>
                    
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.inventario.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"   >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
                <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    agregar={this.toggle_modal_registro}
                />

                {
                   this.state.modal_registro==15&& 
                   <Impuestos 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==17&& 
                   <Marcas 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                 {
                   this.state.modal_registro==18&& 
                   <Estilos 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==20&& 
                   <Medidas 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==19&& 
                   <Colores 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                {
                   this.state.modal_registro==33&& 
                   <Categorias
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                 {
                   this.state.modal_registro==14&& 
                   <Proveedor 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
            </Modal>

        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        inventario : state.inventario,
        notificciones:state.notificciones
    }
};

export default connect(mapStateToProps, actions)(ProveedorModal)


// WEBPACK FOOTER //
// ./src/views/inventario/Modal.js